








import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ui-toolbar-item-change-ico"
})
export default class UiToolbarItemChangeIcoComponent extends Vue {
 @Prop({default:""})
 icon1:string;

 @Prop({default:""})
 icon2:string;

 @Prop({default:false, type:Boolean})
 value:Boolean

 currentIcon=this.icon1;
 innerValue=this.value;
 click(){
   this.innerValue=!this.innerValue;
  if (this.currentIcon==this.icon1){
    
    this.currentIcon=this.icon2;
  }
  else{
      this.currentIcon=this.icon1;
  }
   this.$emit("click", this.innerValue);
 }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-toolbar/src/ui-toolbar-item-change-ico.vue